"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeNumberInput = normalizeNumberInput;
function normalizeNumberInput(val, decimalCount, prevValue) {
  if (!val || val === '-') return val;
  val = val.replace(',', '.');
  const regex = decimalCount > 0 ? new RegExp(`^-?\\d*(\\.\\d{0,${decimalCount}})?$`) : /^-?\d*$/;
  if (!regex.test(val)) return prevValue?.toString();
  if (decimalCount > 0 && val.includes('.')) {
    const [intPart, decPart] = val.split('.');
    if (decPart.length > decimalCount) {
      val = intPart + '.' + decPart.slice(0, decimalCount);
    }
  }
  return val;
}
